import { ComponentType } from 'react';
import { Events } from 'src/graphql/schema.graphql';
import { SearchFilters, SearchItemsToQuery } from 'src/services/search';
import { NeauviaItem } from 'src/models/directus';
import { TaxonomyContextValue } from 'src/modules/materials/providers/TaxonomyContext';
import { NeauviaItemQueryFilters } from 'src/modules/materials/hooks/useNeauviaItemsListQuery';

export enum ShowcaseSection {
  SearchResults = 'searchResults',
  List = 'list',
  Favorites = 'favorites',
  HeroList = 'heroList',
  ProtocolTreatment = 'protocolTreatment',
  BusinessCases = 'businessCases',
}

export interface BaseShowcaseSectionData {
  name: string;
  count?: number;
  taxonomy?: TaxonomyContextValue;
  searchQuery?: SearchFilters;
}

export interface ShowcaseSearchVariables {
  sort?: string[];
  limit?: number;
  itemsToQuery?: SearchItemsToQuery[];
}

export interface BaseShowcaseQuerySectionData extends BaseShowcaseSectionData {
  variables?: ShowcaseSearchVariables & {
    filters?: NeauviaItemQueryFilters;
  };
}

export interface ProtocolTreatmentSectionData extends BaseShowcaseSectionData {
  type: ShowcaseSection.ProtocolTreatment;
}

export interface FavoritesSectionData extends BaseShowcaseSectionData {
  type: ShowcaseSection.Favorites;
}

export interface BusinessCasesSectionData extends BaseShowcaseSectionData {
  type: ShowcaseSection.BusinessCases;
}

export interface ShowcaseListSectionData extends BaseShowcaseQuerySectionData {
  type: ShowcaseSection.List;
}

export interface SearchResultsSectionData extends BaseShowcaseQuerySectionData {
  type: ShowcaseSection.SearchResults;
}

export interface ShowcaseHeroListSectionData
  extends BaseShowcaseQuerySectionData {
  type: ShowcaseSection.HeroList;
}

export type ShowcaseSectionData =
  | ShowcaseListSectionData
  | SearchResultsSectionData
  | FavoritesSectionData
  | ProtocolTreatmentSectionData
  | BusinessCasesSectionData
  | ShowcaseHeroListSectionData;

export type ShowcaseListRenderComponentProps<
  T extends NeauviaItem = NeauviaItem,
> = {
  section: BaseShowcaseQuerySectionData;
  items?: T[];
  event?: Events;
  header?: boolean;
  isLoading?: boolean;
};

export type ShowcaseListRenderComponentType<
  T extends NeauviaItem = NeauviaItem,
> = ComponentType<ShowcaseListRenderComponentProps<T>>;
